import { Fragment } from "react";

import Await from "../components/async/Await";
import Button from "../components/Button/Button";
import OnlyWithPermission from "../components/OnlyWithPermission";
import Spacer from "../components/space/Spacer";
import { useOutgoingRequest } from "../data/tanstack-query";
import { getBrief } from "../endpoints/outgoing-requests";
import { Permission } from "../enums/Permission";
import { briefEditorRoute } from "../screens/BriefEditorNavigator/navigation";
import BriefView from "./BriefView";

type BriefProps = {
    id: string;
};

export default function Brief(props: BriefProps) {
    return (
        <Await>
            <BriefLoader {...props} />
        </Await>
    );
}

function BriefLoader(props: BriefProps) {
    const { id } = props;
    const brief = useOutgoingRequest(getBrief(id));
    return (
        <Fragment>
            <BriefView blocks={brief.blocks} />
            <OnlyWithPermission permission={Permission.Editorial}>
                <Spacer scale={6} />
                <Button
                    action={briefEditorRoute.getLocation({ pathParams: { id } })}
                    label="Éditer"
                />
            </OnlyWithPermission>
        </Fragment>
    );
}
